const SkipAccessoireSelection = (props) => {
    return props.formatAccessoiresComplete && Object.keys(props.accessoires).length === 0
}

export default SkipAccessoireSelection

